import intellegenceService from "../shared/services/intellegenceService";
import getDates from "../shared/services/date.service";
import { setLogout } from "./authActions";

const REQUEST_MAP_ORIGENAL_POSITIONS = "REQUEST_MAP_ORIGENAL_POSITIONS";
const RESPONSE_MAP_ORIGENAL_POSITIONS = "RESPONSE_MAP_ORIGENAL_POSITIONS";
const REQUEST_MAP_ORIGENAL_POSITIONS_FAILURE = "REQUEST_MAP_ORIGENAL_POSITIONS_FAILURE";
const CLEAR_MAP_ORIGENAL_POSITIONS = "CLEAR_MAP_ORIGENAL_POSITIONS";

const requestMapOrigenalPositionsAction = () => {
  return {
    type: REQUEST_MAP_ORIGENAL_POSITIONS,
  };
};

const responseMapOrigenalPositionsAction = (data) => {
  return {
    type: RESPONSE_MAP_ORIGENAL_POSITIONS,
    payload: data,
  };
};

const requestMapOrigenalPositionsFailureAction = (errors) => {
  return {
    type: REQUEST_MAP_ORIGENAL_POSITIONS_FAILURE,
    errors,
  };
};

const getMapOrigenalPositions = (options) => {
  const startDate = getDates.fixISOStringDateToPost(options.startDate);
  const endDate = getDates.fixISOStringDateToPost(options.endDate);

  return (dispatch) => {
    dispatch(requestMapOrigenalPositionsAction());

    intellegenceService
      .getOrigenalPositions(options.carId, {
        startDate,
        endDate,
        timeZone: (new Date().getTimezoneOffset() / 60) * -1,
      })
      .then((result) => {
        dispatch(responseMapOrigenalPositionsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestMapOrigenalPositionsFailureAction(error.response));

        if (error.response && error.response.status === 401) {
          dispatch(setLogout());
        }
      });
  };
};

const clearMapOrigenalPositionsAction = () => {
  return {
    type: CLEAR_MAP_ORIGENAL_POSITIONS,
  };
};

export {
  REQUEST_MAP_ORIGENAL_POSITIONS,
  RESPONSE_MAP_ORIGENAL_POSITIONS,
  REQUEST_MAP_ORIGENAL_POSITIONS_FAILURE,
  CLEAR_MAP_ORIGENAL_POSITIONS,
  requestMapOrigenalPositionsAction,
  responseMapOrigenalPositionsAction,
  requestMapOrigenalPositionsFailureAction,
  getMapOrigenalPositions,
  clearMapOrigenalPositionsAction,
};
